import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDUtilization(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdUtilization(period),
    queryFn: () => dashboardApi.getMDUtilization(period),
  });
}
